/* tslint:disable */
/* eslint-disable */
/**
 * Pricing API
 * API for managing pricing.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeesReferentialDto } from './FeesReferentialDto';
import {
    FeesReferentialDtoFromJSON,
    FeesReferentialDtoFromJSONTyped,
    FeesReferentialDtoToJSON,
    FeesReferentialDtoToJSONTyped,
} from './FeesReferentialDto';

/**
 * 
 * @export
 * @interface CustomContractFunnelItemDto
 */
export interface CustomContractFunnelItemDto {
    /**
     * Hash de la cartouche (identifiant unique côté front)
     * @type {string}
     * @memberof CustomContractFunnelItemDto
     */
    hash: string;
    /**
     * Frais personnalisés pour cette cartouche spécifique
     * @type {Array<FeesReferentialDto>}
     * @memberof CustomContractFunnelItemDto
     */
    fees?: Array<FeesReferentialDto>;
}

/**
 * Check if a given object implements the CustomContractFunnelItemDto interface.
 */
export function instanceOfCustomContractFunnelItemDto(value: object): value is CustomContractFunnelItemDto {
    if (!('hash' in value) || value['hash'] === undefined) return false;
    return true;
}

export function CustomContractFunnelItemDtoFromJSON(json: any): CustomContractFunnelItemDto {
    return CustomContractFunnelItemDtoFromJSONTyped(json, false);
}

export function CustomContractFunnelItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomContractFunnelItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hash': json['hash'],
        'fees': json['fees'] == null ? undefined : ((json['fees'] as Array<any>).map(FeesReferentialDtoFromJSON)),
    };
}

export function CustomContractFunnelItemDtoToJSON(json: any): CustomContractFunnelItemDto {
    return CustomContractFunnelItemDtoToJSONTyped(json, false);
}

export function CustomContractFunnelItemDtoToJSONTyped(value?: CustomContractFunnelItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hash': value['hash'],
        'fees': value['fees'] == null ? undefined : ((value['fees'] as Array<any>).map(FeesReferentialDtoToJSON)),
    };
}

